<template>
  <div style="z-index: 1">
    <b-row>
      <b-col sm="12" class="person">
        <img src="@/assets/question.svg" alt style="fill:rgb(75, 201, 219);" />
        <div class="user">
          <div class="name">{{ question }}</div>
          <div class="role">Тестовое задание</div>
        </div>
      </b-col>
    </b-row>
    <b-row class="variants" style="margin-top:20px; padding-left:80px;">
      <b-col sm="10" v-for="(item, index) in answers" :key="index" @click="answer(item.id)">
        <div
          class="button"
          :class="{'right': result&&item.is_correct&&item.chosen,'wrong': result&&!item.is_correct&&item.chosen, 'disabled':result&&!item.chosen  }"
          
        >{{ item.text }}</div>
      </b-col>
      <b-col sm="10">
      <b-spinner v-if="proccess"></b-spinner>
      </b-col>
    </b-row>
    <b-row style="padding-left:80px;">
      <b-col sm="10" v-if="result" class="result" v-html="result + '<p><i>Остались вопросы? Обсудите задание в нашей <a target=\'_blank\' href=\'https://www.facebook.com/groups/skillslabgame\'>группе в Facebook</a></i></p>'"></b-col>
      
    </b-row>
  </div>
</template>
<script>
import API from "@/api";

export default {
  props: {
    question: String,
    answers: Array,
    result: String, 
    data: Object
  },
   data() {
    return {
      proccess:false
    };
  },
  watch: {
    data: function (val) {
      this.proccess = false
    },
  },
  methods: {
    answer(id) {
      if (!this.result) {
        this.proccess = true
        const config = {
          headers: { Authorization: `Bearer ${this.$store.state.token}` }
        };
        const data = new FormData();
        data.append("answer", id);
        API.post("api/answer/", data, config).then(response => {
          this.$emit("answered");
        });


      }
    }
  }
};
</script>
<style>
.button {
  background-color: white;
  width: 100%;
  padding: 10px 0;
  border-radius: 6px;
  font-family: Open Sans, sans-serif;
  font-weight: bold;
  text-align: center;
  color: #252525;
  border: 1px solid #b1b1b1;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  margin-bottom: 10px;
  text-overflow: ellipsis;
  /* white-space: nowrap; */
  overflow: hidden;
}

.button.wrong {
  background-color: #ff9088 !important;
  color: white;
  cursor: not-allowed;
}
.button.right {
  background-color: #08a2dc !important;
  color: white;
  cursor: not-allowed;
}
.button.disabled {
  background-color: #f3f3f3 !important;
  color: black !important;
  cursor: not-allowed;
}
.button:hover {
  outline: none;
  background-color: #08a2dc;
  border: 1px solid #08a2dc;
  color: #ffffff;
}
.question {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 5px;
  line-height: 20px;
  color: #2e2e2e;
}
.variants {
  width: 100%;
  outline: none;
}

.result {

  border-left: 5px solid #fff3c3;
  margin-top: 20px;
  margin-left: 15px;

  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  color: #4f4f4f;
}
.result p:last-child
{
  margin-bottom: 0px !important;
}
.info {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  color: rgba(0, 0, 0, 0.8);
}
</style>